import { useState, useEffect } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useEffect(() => {
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'faq-schema';
    script.textContent = JSON.stringify(faqSchema);
    const existingScript = document.getElementById('faq-schema');
    if (existingScript) existingScript.remove();
    document.head.appendChild(script);
    return () => {
      const s = document.getElementById('faq-schema');
      if (s) s.remove();
    };
  }, []);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于海角论坛的常见疑问与解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div
                  className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}